export default "__VITE_ASSET__BNvLbAPK__"